import { connect } from 'react-redux';
import AddQuote from "../Component/AddQuote";
import {
  checkZipCode,
  addQuote,
  updateQuote,
  getQuoteById,
  resetCheckZipcode,
  checkEmail,
  checkMail,
  addCommercialProposal,
  addInnerCommercialProposal,
  getGeocodeAddress,
  resetGeocodeAddress
} from '../../../../Action'

const mapStateToProps = (state) => {
  const { ZipcodeCheck, CommercialProposal, CheckMailStatus, GoogleApi } = state;
  return {
    ZipcodeCheck, CommercialProposal, CheckMailStatus, GoogleApi
  }
}

const actionCreators = {
  resetCheckZipcode,
  checkZipCode,
  addQuote,
  updateQuote,
  getQuoteById,
  addCommercialProposal,
  addInnerCommercialProposal,
  checkEmail,
  checkMail,
  getGeocodeAddress,
  resetGeocodeAddress
}
export default (connect(mapStateToProps, actionCreators)(AddQuote));